import { Sparkle } from "lucide-react";
import { useSiteData } from "../../context/SiteData";

const Row = ({ items }) => (
  <div className="flex items-center shrink-0">
    {items.map((item) => (
      <span key={item} className="flex items-center">
        <span className="font-display font-bold uppercase tracking-[0.2em] text-sm sm:text-base text-white px-8">
          {item}
        </span>
        <Sparkle className="w-4 h-4 text-white/60 fill-white/60 shrink-0" />
      </span>
    ))}
  </div>
);

export const Marquee = () => {
  const { content, settings } = useSiteData();
  const items = content.marquee_items.length ? content.marquee_items : ["Voyage Switzerland"];
  // Marquee speed (seconds per loop) — admin-controlled, higher = slower.
  const speed = Number(settings.marquee_speed) || 46;

  return (
    <section data-testid="editorial-marquee" className="relative py-6 overflow-hidden">
      <div className="bg-[var(--brand)] -rotate-1 scale-[1.02] shadow-xl shadow-[var(--brand)]/25">
        <div className="flex w-max animate-marquee-drift py-4" style={{ animationDuration: `${speed}s` }} data-testid="marquee-track">
          <Row items={items} />
          <Row items={items} />
          <Row items={items} />
          <Row items={items} />
        </div>
      </div>
    </section>
  );
};
